
import {updateUserInfo,insertUserInfo} from '@/api/shopapi'

export const setuser = ({commit},user) => {
    commit('SETUSER',user)
}
export const sethisuser = ({commit},hisuser) => {
  commit('SETHISUSER',hisuser)
}


export const inserteuser = ({commit},user) =>{
  insertUserInfo(user).then(res=>{
    commit('SETUSER',user)
  }).catch(e=>console.log(e))

}

export const updateuser = ({commit},user) =>{
    updateUserInfo(user).then(res=>{
      commit('SETUSER',user)
    }).catch(e=>console.log(e))
}

export const updateauserasync = ({commit},user) =>{
  return updateUserInfo(user)
}
export const setPartList = ({commit},partlist) => {
  commit('SETPARTLIST',partlist)
}

export const setGood = ({commit},good) => {
  commit('SETGOOD',good)
}
export const setOrderGood = ({commit},orderGood) => {
  commit('SETORDERGOOD',orderGood)
}
export const setAddressList = ({commit},addressList) => {
  commit('SETADDRESSLIST',addressList)
}
export const setAddressId = ({commit},addressId) => {
  commit('SETADDRESSID',addressId)
}
export const editAddress = ({commit},editAddress) => {
  commit('EDITADDRESS',editAddress)
}
export const setInsuranceOrderList = ({commit},insuranceOrderList) => {
  commit('SETINSURANCEORDERLIST',insuranceOrderList)
}
export const setInsurance = ({commit},insuarance) => {
  commit('SETINSURANCE',insuarance)
}
export const setHBgoods = ({commit},HBgoods) => {
  commit('SETHBGOODS',HBgoods)
}
export const setItemmap = ({commit},itemmap) => {
  commit('SETITEMMAP',itemmap)
}

export const setActivity = ({commit},Activity) => {
  commit('SETACTIVITY',Activity)
}
export const setEshopGood = ({commit},eshopGood) => {
  commit('SETESHOPGOOD',eshopGood)
}
export const setnItemmap = ({commit},nitemmap) => {
  commit('SETNITEMMAP',nitemmap)
}
export const setOrderDetails = ({commit},orderDetails) => {
  commit('SETORDERDETAILS',orderDetails)
}
export const setCouponNum = ({commit},CouponNum) => {
  commit('SETCOUPONNUM',CouponNum)
}
export const setHealthItem = ({commit},healthItem) => {
  commit('SETHEALTHITEM',healthItem)
}
// export const setEshopUserInfo = ({commit},eshopUserInfo) => {
//   commit('SETESHOPUSERINFO',eshopUserInfo)
// }
export const nextItem = ({commit},active) => {
  commit('NEXTITEM',active)
}
export const preItem = ({commit},active) => {
  commit('PREITEM',active)
}
export const setErrorExam = ({commit},setErrorExam) => {
  commit('SETERROREXAM',setErrorExam)
}
export const setExamInfo = ({commit},examInfo) => {
  commit('SETEXAMINFO',examInfo)
}
export const reSetCurrendIndex = ({commit}) => {
  commit('RESETCURRENDINDEX')
}
export const setCurrendIndex = ({commit},currendIndex) => {
  commit('SETCURRENDINDEX',currendIndex)
}
export const setSaveAnswer = ({commit},saveAnswer) => {
  commit('SETSAVEANSWER',saveAnswer)
}
export const reSetSaveAnswer = ({commit},saveAnswer) => {
  commit('RESETSAVEANSWER',saveAnswer)
}
export const setErrorExamp = ({commit},setErrorExam) => {
  commit('SETERROREXAMP',setErrorExam)
}
export const setAllExamp = ({commit},setAllExamp) => {
  commit('SETALLEXAMP',setAllExamp)
}
export const setExamInfop = ({commit},examInfo) => {
  commit('SETEXAMINFOP',examInfo)
}
export const setSaveAnswerp = ({commit},saveAnswer) => {
  commit('SETSAVEANSWERP',saveAnswer)
}
export const reSetSaveAnswerp = ({commit},saveAnswer) => {
  commit('RESETSAVEANSWERP',saveAnswer)
}
export const setJobDetail = ({commit},jobDetail) => {
  commit('SETJOBDETAIL',jobDetail)
}
export const setMyToken = ({commit},myToken) => {
  commit('SETMYTOKEN',myToken)
}
export const setExamType = ({commit},examType) => {
  commit('SETEXAMTYPE',examType)
}
export const setSurveyInfo = ({commit},surveyInfo) => {
  commit('SETSURVEYINFO',surveyInfo)
}
export const setSchoolList = ({commit}, list) => {
  commit('SETSCHOOLLIST', list)
}
export const setMediaTeamUserList = ({commit}, mediaTeamUserList) => {
  commit('SETMEDIATEAMUSERLIST', mediaTeamUserList)
}
export const setRd = ({commit}, rd) => {
  commit('SETRD', rd)
}
export const setPlayId = ({commit}, rd) => {
  commit('SETPLAYID', rd)
}
export const setCurrentPath = ({commit}, currentPath) => {
  commit('SETCURRENTPATH', currentPath)
}
export const setTestResultText = ({commit}, testResultText) => {
  commit('SETTESTRESULTTEXT', testResultText)
}
export const setJdCategoryId = ({commit}, jdCategoryId) => {
  commit('SETJDCATEGORYID', jdCategoryId)
}
export const setJdOptions = ({commit}, jdOptions) => {
  commit('SETJDOPTIONS', jdOptions)
}
export const setDjUser = ({commit}, jdOptions) => {
  commit('SETDJUSER', jdOptions)
}
export const setShop = ({commit}, shop) => {
  commit('SETSHOP', shop)
}
